<template>
  <RequestWizardStep name="Contact Info" :complete="isComplete">
    <ContentCard
      v-if="is3rdParty"
      title="Great!  We can help you get the Medicare records."
    >
      <p class="lead">Please tell us about the individual with Medicare:</p>

      <CompleteFormMessage class="mb-4" />

      <DynamicForm
        :fields="onBehalfFields"
        class="row g-3"
        v-model="nonCommonData.contactInfo"
      />

      <p
        class="lead mb-4 mt-5"
      >
        If you have a case associated with this beneficiary, please enter the tracking number:
      </p>

      <TextBox
        label="Reference Number"
        :rules="{ max: maxLength(20) }"
        v-model="nonCommonData.contactInfo.externalCaseNumber"
      />
    </ContentCard>

    <ContentCard
      :title="!is3rdParty ? 'Great! We can help you get your Medicare records.' : null"
    >
      <div class="mb-4">
      <template v-if="is3rdParty">
        <p class="lead">
          We also need you to enter information for the individual and/or
          organization who will be receiving the Medicare claims records. This individual will
          serve as the point of contact if any questions should arise while fulfilling the
          request.
        </p>
      </template>
      <template v-else>
        <p class="lead">
          Please tell us a little bit more about yourself:
        </p>

        <CompleteFormMessage />
      </template>
      </div>

      <DynamicForm
        :fields="fromFields"
        class="row g-3"
        v-model="nonCommonData.contactInfo"
      />
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import DynamicForm from '@ssi/vue-common/src/components/formControls/DynamicForm';
import { TextBox } from '@/components/formFields/common';
import CompleteFormMessage from '@/components/formFields/CompleteFormMessage';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';
import { maxLength, required } from '@/validators';
import {
  firstName, lastName, organization, birthDate, medicareNum, address1, address2,
  city, state, zip, email, phone, fax
} from './fields';
import { is3rdParty, nonCommonData } from '../../requestWizardState';

export default {
  setup() {
    const v$ = useVuelidate();

    return {
      is3rdParty,
      maxLength,
      nonCommonData,
      v$
    };
  },

  components: {
    CompleteFormMessage, DynamicForm, RequestWizardStep, TextBox
  },

  computed: {
    isComplete: ({ v$ }) => !v$.$invalid,

    fromFields: () => [
      { ...firstName, name: 'fromFirstName' },
      { ...lastName, name: 'fromLastName' },
      {
        ...organization,
        name: 'fromOrganization',
        visible: is3rdParty.value
      },
      {
        ...birthDate,
        name: 'fromBirthDate',
        visible: !is3rdParty.value
      },
      {
        ...medicareNum,
        name: 'fromMedicareNumber',
        visible: !is3rdParty.value,
        rules: {
          ...medicareNum.rules,
          required
        }
      },
      { ...address1, name: 'fromAddressLine1' },
      { ...address2, name: 'fromAddressLine2' },
      { ...city, name: 'fromCity' },
      { ...state, name: 'fromState' },
      { ...zip, name: 'fromZip' },
      { ...email, name: 'fromEmail' },
      { ...phone, name: 'fromPhone' },
      { ...fax, name: 'fromFax', }
    ],

    onBehalfFields: () => [
      { ...firstName, name: 'onBehalfOfFirstName' },
      { ...lastName, name: 'onBehalfOfLastName' },
      { ...birthDate, name: 'onBehalfOfBirthDate' },
      { ...medicareNum, name: 'onBehalfOfMedicareNumber' },
      { ...address1, name: 'onBehalfOfAddressLine1' },
      { ...address2, name: 'onBehalfOfAddressLine2' },
      { ...city, name: 'onBehalfOfCity' },
      { ...state, name: 'onBehalfOfState' },
      { ...zip, name: 'onBehalfOfZip' }
    ]
  }
};
</script>
